const colors = {
    main: '#21406A',
    primary: '#005FA5',
    secondary: '#3e82b8',
    tertiary: '#f2f2f2',
    highlight: '#ffd07d',
    active: '#32B11E',
    red: '#D73948',
    warning: {
        main: '#FFD07D',
        light: '#FFF4E2'
    },
    danger: {
        main: '#EB7F37',
        light: '#FCF0E8'
    }
};

export default colors;
